export default {
  monthFormat: 'MMMM', formatLocale: {firstDayOfWeek: 1}
}